import { ReactElement, useCallback } from 'react'
import SingleUnitBox from './SingleUnitBox'
import { Box } from '@mui/material'
import { temperatureUnits } from '../../../constants/constants'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import { updateGuestUserPreferredUnit } from '../../../redux/slices/entityViewSlice'

const GuestUserUnitPreferences = (): ReactElement => {
    const selectedTempUnit = useAppSelector(
        (state) => state.entityInstanceView.guestUserPreferredUnit,
    )
    const dispatch = useAppDispatch()

    const onChangeUnits = useCallback(
        (unit: string) => {
            dispatch(updateGuestUserPreferredUnit(unit))
        },
        [dispatch],
    )

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
            }}
        >
            {temperatureUnits.map((unit: string) => {
                return (
                    <Box sx={{ marginRight: '5px' }} key={unit}>
                        <SingleUnitBox
                            isSelected={selectedTempUnit === unit}
                            unit={unit}
                            onChangeUnits={onChangeUnits}
                        />
                    </Box>
                )
            })}
        </Box>
    )
}

export default GuestUserUnitPreferences
